import React, { FC } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import Button from 'src/common/components/ButtonDS22';
import CostBreakdown from 'src/common/components/CostBreakdown';
import { useTripCartOptionsContext } from 'src/trip-cart/hooks/useTripCartOptionsContext';
import { useCurrencyContext } from 'src/common/providers/CurrencyProvider';
import AddonCostPanel from 'src/common/components/AddonCostPanel';
import { useTripCartContext } from 'src/trip-cart/hooks/useTripCartContext';
import TripCartPanelContent from 'src/trip-cart/components/panel/TripCartPanelContent';
import styles from './TripCartPanelPriceDetails.module.scss';

const TripCartPanelPriceDetails: FC = () => {
  const [t] = useTranslation('listing-page');
  const { prices, options: { isCostConfirmed } } = useTripCartOptionsContext();
  const { currency } = useCurrencyContext();
  const {
    addonsOptional, addonsLater, closePanel,
  } = useTripCartContext();

  return (
    <TripCartPanelContent
      title={t('trip-cart--drawer-footer--price-details')}
      subtitle={!isCostConfirmed ? (
        <Trans
          t={t}
          i18nKey="trip-cart--price-details--description"
          components={[<strong />]}
        />
      ) : ''}
    >
      <div className={styles.root}>
        {prices.price_sections?.map((section) => (
          <CostBreakdown
            key={section.id}
            priceSection={section}
            renterCurrency={currency}
            showFooter={false}
            noPricesMarginBottom
          />
        ))}
        {addonsLater && addonsLater.length > 0 && (
          <AddonCostPanel
            addons={addonsLater}
            type="later"
          />
        )}
        {addonsOptional && addonsOptional.length > 0 && (
          <AddonCostPanel
            addons={addonsOptional}
            type="optional"
          />
        )}
      </div>
      <div className={styles.footer}>
        <Button
          variant="secondary"
          onClick={() => closePanel()}
        >
          {t('trip-cart--action-done')}
        </Button>
      </div>
    </TripCartPanelContent>
  );
};

export default TripCartPanelPriceDetails;
